import { TASK_PAGE_ICON_KEYS, type TaskPageIconKey } from '@erp/shared-types';
import { cn } from 'src/lib/utils';
import { TASK_PAGE_ICON_COMPONENTS } from './taskPageIcons';

/**
 * Toggle-button grid over the shared sidebar-page icon set. Used by both the
 * task page and agent page editors (they share one icon vocabulary).
 */
export function PageIconPicker({
  value,
  onChange,
}: {
  value: TaskPageIconKey | null;
  onChange: (icon: TaskPageIconKey | null) => void;
}) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {TASK_PAGE_ICON_KEYS.map((key) => {
        const IconComponent = TASK_PAGE_ICON_COMPONENTS[key];
        const selected = value === key;
        return (
          <button
            key={key}
            type="button"
            aria-label={key}
            aria-pressed={selected}
            onClick={() => onChange(selected ? null : key)}
            className={cn(
              'flex size-8 items-center justify-center rounded border transition-colors',
              selected
                ? 'border-stone-900 bg-stone-100 text-stone-900'
                : 'border-border text-stone-500 hover:bg-stone-50',
            )}
          >
            <IconComponent className="size-4" />
          </button>
        );
      })}
    </div>
  );
}
